import { TextField } from '@mui/material';
import CustomButton from '../../reusable/CustomButton';
import { Dispatch, SetStateAction, useState } from 'react';
import { DemographicCategory, DemographicValue } from '../../../interfaces/EOAInterface';
import AddedItems from './AddedItems';

interface NewDemographicValueProps {
  label: string;
  category: DemographicCategory;
  setCategory: Dispatch<SetStateAction<DemographicCategory>>;
  defaultCategoryValues?: DemographicValue[];
  required?: boolean;
}

function NewDemographicValue({label, category, setCategory, defaultCategoryValues, required}: NewDemographicValueProps) {

  const [newDistrictName, setNewDistrictName] = useState('');

  const isDeletable = (name: string) => {
    return !defaultCategoryValues?.some(category => category.district_name === name);
  };  

  const handleAddNewCategory = () => {

    const newDemographicValue = {
      district_name: newDistrictName,
      aliases: [],
    };
  
    setCategory(prev => ({...prev, demographic_values: [...prev.demographic_values, newDemographicValue]}));
    setNewDistrictName('');
  };

  const handleDeleteCategory = (name: string) => {
    const filteredDemographicValues = category.demographic_values.filter(category => category.district_name !== name);
    setCategory(prev => ({...prev, demographic_values: filteredDemographicValues}));
  };
  
  return (
    <>
      <h4>New {label}</h4>
      <TextField
        placeholder={`${label} ${required ? '*' : ''}`}
        variant="outlined"
        value={newDistrictName}
        onChange={(e) => setNewDistrictName(e.target.value)}
      />
      <AddedItems 
        addedItems={category.demographic_values.map(value => value.district_name)}
        isDeletable={isDeletable}
        handleDelete={(name) => handleDeleteCategory(name)}
      />
      <CustomButton
        variant="primary"
        size="medium"
        disabled={!newDistrictName.trim()}
        buttonText={`Add ${label}`}
        buttonAction={handleAddNewCategory}
      />
    </>
  );
}

export default NewDemographicValue;